<template>
    <ValidationObserver :ref="stepName" v-slot="observer">

        <div v-for="(field,name) in fields" :key="name" class="field-container">
            <component :is="field._component" :key="name" :name="name" :field="field" :step="step"></component>
        </div>
        <b-button type="button is-primary next-button" :disabled="block_form" v-html="step._button" @click="nextStep()"></b-button>

    </ValidationObserver>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import form_step_mixin from '../../../form_step_mixin'
import {Text} from "../../../../../../models/fields/Text";
import {Checkbox} from "../../../../../../models/fields/Checkbox";
import Vue from 'vue';
import modal_mixin from "../../../../../../views/_commons/nl/mixins/modal_mixin";

export default {
    mixins: [mixin, form_step_mixin, modal_mixin],
    methods: {
        generateOptinLabel(template){
            let compiledComponent = Vue.compile(template);
            let componentLogic = {
                mixins: [modal_mixin]
            }
            return {...compiledComponent, ...componentLogic}
        },
    },
    data() {
        return {
            fields: {
                email: new Text().type('email').label('E-mailadres').placeholder('vb. email@gmail.com').required().validation({email: true, max:254}),
                optin_terms_conditions: new Checkbox()
                    .label(this.generateOptinLabel('<div>Ik verklaar de <a @click.prevent="openModal(\'infos\',\'conditions\')">algemene voorwaarden</a> gelezen te hebben en te aanvaarden.</div>')).required(),
                optin_privacy: new Checkbox()
                    .label(this.generateOptinLabel('<div>Ik verklaar de <a @click.prevent="openModal(\'infos\',\'privacy\')">privacybepalingen</a> gelezen te hebben en te aanvaarden</div>')).required(),
            }
        }
    },
}
</script>
